import { ReactNode } from 'react'

interface ILabelProps {
    label: ReactNode
    styleType?: ILabelStyleType
}

export type ILabelStyleType = 'bold' | 'default'

export const Label = ({ label, styleType = 'default' }: ILabelProps) => {
    return (
        <div
            className="flex flex-row items-center font-bold text-[14px]"
            style={getStyleTypeStyles(styleType)}
        >
            {label}
        </div>
    )
}

function getStyleTypeStyles(styleType: ILabelStyleType): React.CSSProperties {
    switch (styleType) {
        case 'bold':
            return { fontWeight: 600, fontSize: '20px' }
        default:
            return { fontWeight: 400, fontSize: '14px', opacity: 0.4 }
    }
}
